import {
  NumericalThresholdData,
  DateThresholdData,
} from '../types/thresholds.js';
import { isStatic, isDynamicNumeric, isDynamic } from '../types/type-guards.js';

const isDot = (threshold: DateThresholdData | NumericalThresholdData) =>
  isStatic(threshold) || isDynamic(threshold) || isDynamicNumeric(threshold);

export const sortThresholds = (
  threshold1: DateThresholdData | NumericalThresholdData,
  threshold2: DateThresholdData | NumericalThresholdData,
): number => +isDot(threshold1) - +isDot(threshold2);
